import { firebaseAuth } from './firebase';

// logs out from auth (returns promise)
export const logout = () => firebaseAuth().signOut().catch((error) => console.error("Error on logout", error));

// signs the user in
export async function login(email, password) {
    await firebaseAuth().setPersistence(firebaseAuth.Auth.Persistence.LOCAL)
        .then(() => firebaseAuth().signInWithEmailAndPassword(email, password)
            .catch((error) => console.error("Error on login", error)));
}

// signs up a new user
export async function register(email, password, name) {
    await firebaseAuth().setPersistence(firebaseAuth.Auth.Persistence.LOCAL)
        .then(() => firebaseAuth().createUserWithEmailAndPassword(email, password)
            .then(function (result) { return result.user.updateProfile({ displayName: name }) })
            .catch((error) => console.error("Error on register", error)));
}

// gets the current user
export const getCurrentUser = () => new Promise((resolve) => {firebaseAuth().onAuthStateChanged((user) => resolve(user))});

// forgot password
export const forgotPasswort = (email) => firebaseAuth().sendPasswordResetEmail(email).catch((error) => console.error("Error on forgotPassword", error));